import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { LoginForm } from './LoginForm';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredPermission?: string;
  fallback?: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiredPermission,
  fallback,
}) => {
  const { isAuthenticated, arePermisiune, loading } = useAuth();

  // Show loading state while checking authentication
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="flex items-center space-x-2">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-primary"></div>
          <span>Se verifică autentificarea...</span>
        </div>
      </div>
    );
  }

  // If not authenticated, show fallback or login form
  if (!isAuthenticated) {
    return fallback ? <>{fallback}</> : (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <LoginForm />
      </div>
    );
  }

  // If authenticated but doesn't have required permission
  if (requiredPermission && !arePermisiune(requiredPermission)) {
    if (fallback) {
      return <>{fallback}</>;
    }
    
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            Acces restricționat
          </h2>
          <p className="text-gray-600">
            Nu aveți permisiunea să accesați această pagină.
          </p>
        </div>
      </div>
    );
  }

  // If authenticated and has permission (or no permission required)
  return <>{children}</>;
};